<!-- jQuery Code -->
function calculatePricePerGram() {
	$('.product-grid li.grid-item-powder').each(function () {
		var unitPriceCents = $(this).find('.unit-price-custom').data('price'); // Get unit price for this product
		var totalGrams = $(this).find('.total-grams').data('grams'); // Get total grams for this product
		var currencyType = $(this).find('.currency-type').data('currency'); // Dynamically fetch currency for this product

		// Log the values to check
		console.log('Unit Price (cents):', unitPriceCents);
		console.log('Total Grams:', totalGrams);
		console.log('Currency Type:', currencyType); // Check this output

		// Ensure values are converted to numbers before calculations
		unitPriceCents = parseFloat(unitPriceCents); // e.g., 3299
		totalGrams = parseFloat(totalGrams); // e.g., 1000

		// Calculate price per gram in dollars
		if (totalGrams > 0) {
			//var pricePerGram = (unitPriceCents / totalGrams) / 100; // Price per gram in dollars
             var pricePerGram = ((unitPriceCents / totalGrams) / 100) * 1000; // Price per gram in dollars
			// Format as money using dynamic currency
			var formattedPrice = pricePerGram.toLocaleString('nl-NL', {
				style: 'currency',
				currency: currencyType,
				currencyDisplay: 'symbol', // Ensures symbol (€, $, etc.) is used
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});

			// var formattedPrice = currencyType + ' ' + formattedPrice; // Will result in "€ 0,039"

			// Update the corresponding price per gram display
			$(this).find('#pricePerGram').text(formattedPrice); // Display the formatted price
		} else {
			$(this).find('#pricePerGram').text('N/A'); // Handle case with zero grams
		}
	});
}


function calculateAndLogPricePerTablet() {
	$('.product-grid li.grid-item-tablet').each(function () {
		// Get product details from the element
		var totalGrams = $(this).find('.total-grams').data('grams'); // Package weight in grams
		var tabletWeightMg = 500; // Tablet weight in mg
		var unitPriceCents = $(this).find('.unit-price-custom').data('price'); // Price in cents
		var currencyType = $(this).find('.currency-type').data('currency'); // Currency type

		// Calculate total tablets
		var totalTablets = totalGrams; // Convert grams to mg and calculate tablets

		if (totalTablets > 0) {
			// Calculate price per tablet
			//var pricePerTablet = (unitPriceCents / totalTablets) / 100; // Convert price from cents to currency
            var pricePerTablet = ((unitPriceCents / totalGrams) / 100) * 1000; // Price per kg in dollars
			// Format the price per tablet in the desired currency
			var formattedPrice = pricePerTablet.toLocaleString('nl-NL', {
				style: 'currency',
				currency: currencyType, // e.g., 'EUR'
				currencyDisplay: 'symbol',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});

			// Log the results
			console.log('Total tablets in package:', totalTablets);
			console.log('Price per tablet:', formattedPrice);
			$(this).find('#pricePerGram').text(formattedPrice);
		} else {
			console.log('N/A - No tablets found');
		}
	});
}

// Apply function to each product


$(document).ready(function () {
	if ($('.main-product-page-powder').length > 0) {
		// Fetch the data from the HTML
		var unitPriceCents = $('.main-product-page-powder').find('.unit-price-custom').data('price'); // should be 3299
		var totalGrams = $('.main-product-page-powder').find('.total-grams').data('grams'); // should be 1000
		var currencyType = $('.main-product-page-powder').find('.currency-type').data('currency');

		// Log the values to check
		console.log('Unit Price (cents):', unitPriceCents); // Check this output
		console.log('Total Grams:', totalGrams); // Check this output

		// Ensure values are converted to numbers before calculations
		unitPriceCents = parseFloat(unitPriceCents); // 3299
		totalGrams = parseFloat(totalGrams); // 1000

		// Calculate price per gram in dollars
		if (totalGrams > 0) {
			//var pricePerGram = (unitPriceCents / totalGrams) / 100; // Price per gram in dollars
			var pricePerGram = ((unitPriceCents / totalGrams) / 100) * 1000; // Price per kilogram in dollars
			// Format as money using dynamic currency
			var formattedPrice = pricePerGram.toLocaleString('nl-NL', {
				style: 'currency',
				currency: currencyType,
				currencyDisplay: 'symbol', // Ensures symbol (€, $, etc.) is used
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});

			// var formattedPrice = currencyType + ' ' + formattedPrice; // Will result in "€ 0,039"
			$('.main-product-page-powder').find('#pricePerGram').text(formattedPrice); // Display the formatted price
		} else {
			$('.main-product-page-powder').find('#pricePerGram').text('N/A'); // Handle case with zero grams
		}
	}

	if ($('.main-product-page-tablet').length > 0) {
		var totalGrams = $(this).find('.total-grams').data('grams'); // Package weight in grams
		var tabletWeightMg = 500; // Tablet weight in mg
		var unitPriceCents = $(this).find('.unit-price-custom').data('price'); // Price in cents
		var currencyType = $(this).find('.currency-type').data('currency'); // Currency type

		// Calculate total tablets
		var totalTablets = Math.floor((totalGrams * 1000) / tabletWeightMg); // Convert grams to mg and calculate tablets

		if (totalTablets > 0) {
			// Calculate price per tablet
			//var pricePerTablet = (unitPriceCents / totalTablets) / 100; // Convert price from cents to currency
            var pricePerTablet =  ((unitPriceCents / totalGrams) / 100) * 1000; // Price per kg in dollars
			// Format the price per tablet in the desired currency
			var formattedPrice = pricePerTablet.toLocaleString('nl-NL', {
				style: 'currency',
				currency: currencyType, // e.g., 'EUR'
				currencyDisplay: 'symbol',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});

			// Log the results
			console.log('Total tablets in package:', totalTablets);
			console.log('Price per tablet:', formattedPrice);
			$(this).find('#pricePerGram').text(formattedPrice);
		} else {
			console.log('N/A - No tablets found');
		}
	}


	// Call the function on page load
	calculatePricePerGram();
	calculateAndLogPricePerTablet();
	// tabbed content
	// http://www.entheosweb.com/tutorials/css/tabs.asp
	$(".tab_content").hide();
	$(".tab_content:first").show();

	/* if in tab mode */
	$("ul.tabs li").on('click', function () {

		$(".tab_content").hide();
		var activeTab = $(this).attr("rel");
		$("#" + activeTab).fadeIn();

		$("ul.tabs li").removeClass("active");
		$(this).addClass("active");

		$(".tab_drawer_heading").removeClass("d_active");
		$(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
		calculatePricePerGram();
		calculateAndLogPricePerTablet();
	});
	/* if in drawer mode */
	$(".tab_drawer_heading").on('click', function () {

		$(".tab_content").hide();
		var d_activeTab = $(this).attr("rel");
		$("#" + d_activeTab).fadeIn();

		$(".tab_drawer_heading").removeClass("d_active");
		$(this).addClass("d_active");

		$("ul.tabs li").removeClass("active");
		$("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
		calculatePricePerGram();
		calculateAndLogPricePerTablet();
	});


	/* Extra class "tab_last" 
	   to add border to right side
	   of last tab */
	$('ul.tabs li').last().addClass("tab_last");

	function updateCartIconPosition() {
		if ($(window).width() <= 767) {
			// Move the element for mobile view
			$('#cart-icon-bubble').appendTo('.header-mobile-right .cart-mobile-icon'); // Change '.mobile-menu' to the desired parent container for mobile
		}
	}

	// Run the function on page load
	updateCartIconPosition();

	// Also run the function when window is resized
	$(window).resize(function () {
		updateCartIconPosition();
	});

	mobileOnlySlider(".tab_container .product-grid", true, false, 767);

	function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {

		var slider = $($slidername);
		var settings = {
			mobileFirst: true,
			dots: $dots,
			arrows: $arrows,
			centerMode: true,
			slidesToShow: 1,
			centerPadding: '80px',
			infinite: true,
			autoplaySpeed: 100000,
			autoplay: true,
			speed: 300,
			responsive: [{
				breakpoint: $breakpoint,
				settings: "unslick"
			}]
		};

		slider.slick(settings);

		$(window).on("resize", function () {
			if ($(window).width() > $breakpoint) {
				return;
			}
			if (!slider.hasClass("slick-initialized")) {
				return slider.slick(settings);
			}
		});
		// Refresh Slick slider when a tab is clicked
		$('ul.tabs li').on('click', function () {
			setTimeout(function () {
				slider.slick('setPosition');
			}, 100); // Slight delay to allow for tab content rendering
		});
	} // Mobile Only Slider

	// Related product Slider

	setTimeout(function () {
		RelatedProductSlider(".custom-related-product", true, false, 767);

		function RelatedProductSlider($slidername, $dots, $arrows, $breakpoint) {
			var slider = $($slidername);
			var settings = {
				mobileFirst: true,
				dots: $dots,
				arrows: $arrows,
				centerMode: true,
				slidesToShow: 1,
				centerPadding: '80px',
				infinite: true,
				autoplaySpeed: 100000,
				autoplay: true,
				speed: 300,
				responsive: [{
					breakpoint: $breakpoint,
					settings: "unslick"
				}]
			};

			slider.slick(settings);

			$(window).on("resize", function () {
				if ($(window).width() > $breakpoint) {
					return;
				}
				if (!slider.hasClass("slick-initialized")) {
					return slider.slick(settings);
				}
			});
		} // Mobile Only Slider

	}, 2500);


	//Scroll back to top

	(function ($) {
		"use strict";

		$(document).ready(function () {
			"use strict";

			var progressPath = document.querySelector('.progress-wrap path');
			var pathLength = progressPath.getTotalLength();
			progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
			progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
			progressPath.style.strokeDashoffset = pathLength;
			progressPath.getBoundingClientRect();
			progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
			var updateProgress = function () {
				var scroll = $(window).scrollTop();
				var height = $(document).height() - $(window).height();
				var progress = pathLength - (scroll * pathLength / height);
				progressPath.style.strokeDashoffset = progress;
			}
			updateProgress();
			$(window).scroll(updateProgress);
			var offset = 50;
			var duration = 550;
			jQuery(window).on('scroll', function () {
				if (jQuery(this).scrollTop() > offset) {
					jQuery('.progress-wrap').addClass('active-progress');
				} else {
					jQuery('.progress-wrap').removeClass('active-progress');
				}
			});
			jQuery('.progress-wrap').on('click', function (event) {
				event.preventDefault();
				jQuery('html, body').animate({
					scrollTop: 0
				}, duration);
				return false;
			})


		});

	})(jQuery);

	function getExpectedDeliveryDay(orderTime, locale) {
		const today = new Date();
		let deliveryDate;

		// Check if the order was placed after 12 PM (12:00)
		const orderHour = orderTime.getHours();
		const orderCutoffTime = 12; // 12 PM

		if (today.getDay() >= 1 && today.getDay() <= 5) { // Mon-Fri
			deliveryDate = new Date(today);
			if (orderHour >= orderCutoffTime) {
				deliveryDate.setDate(today.getDate() + 1); // Next day delivery
			} else {
				deliveryDate.setDate(today.getDate() + 1); // Next day delivery
			}
		} else if (today.getDay() === 6) { // Saturday
			deliveryDate = new Date(today);
			deliveryDate.setDate(today.getDate() + 2); // Delivery on Monday
		} else { // Sunday
			deliveryDate = new Date(today);
			deliveryDate.setDate(today.getDate() + 1); // Delivery on Monday
		}

		// Get the day name in the specified locale
		const options = {
			weekday: 'long'
		};
		return deliveryDate.toLocaleDateString(locale, options);
	}

	// Simulate an order placed today at 12:10 PM
	const orderTime = new Date();
	orderTime.setHours(12, 10); // Set time to 12:10 PM

	// Function to update delivery day based on selected language
	function updateDeliveryDay() {
		const selectedLocale = $('.local-lang-code').val();
		$('#expected-delivery').text(getExpectedDeliveryDay(orderTime, selectedLocale));
	}

	// Set initial delivery day based on default language
	updateDeliveryDay();

	// Update delivery day when language is changed
	$('#language').on('change', updateDeliveryDay);
});
console.log($('#expected-delivery').text());


$(window).on("load", function () {
	const addPageLink = setInterval(function () {
		if ($('product-recommendations').length > 0) {
			calculatePricePerGram();
			calculateAndLogPricePerTablet();
			clearInterval(addPageLink); // Clear interval only when the element is found
		}
		clearInterval(addPageLink);
	}, 3000);
});


$(document).ready(function () {
	function calculatePricePerGramvariant(unitPriceCents, totalGrams, currencyType) {
		unitPriceCents = parseFloat(unitPriceCents);
		totalGrams = parseFloat(totalGrams);
		if (totalGrams > 0) {
			//var pricePerGram = (unitPriceCents / totalGrams) / 100; // Price per gram in dollars
			var pricePerGram = ((unitPriceCents / totalGrams) / 100) * 1000; // Price per kg in dollars
			// Format as money using dynamic currency
			var formattedPrice = pricePerGram.toLocaleString('nl-NL', {
				style: 'currency',
				currency: currencyType,
				currencyDisplay: 'symbol', // Ensures symbol (€, $, etc.) is used
				minimumFractionDigits: 3,
				maximumFractionDigits: 3
			});

			// var formattedPrice = currencyType + ' ' + formattedPrice; // Will result in "€ 0,039"
			// Log the formatted price and update the DOM
			console.log($('.main-product-page-powder').find('.price-per-gram').children().text(formattedPrice), formattedPrice, 'formattedPrice');

			// Update the price-per-gram element with the formatted price
			// $('.main-product-page-powder').find('.price-per-gram').children().text(formattedPrice);
			$('#pricePerGram').text(formattedPrice);

		} else {
			// $('.main-product-page-powder').find('.price-per-gram').children().text('N/A');
		}
	}

	function calculatePricePerGramtabletvariant(unitPriceCents, totalGrams, currencyType) {
		var totalGrams = parseFloat(totalGrams); // Package weight in grams
		var tabletWeightMg = 500; // Tablet weight in mg
		var unitPriceCents = parseFloat(unitPriceCents); // Price in cents
		// Calculate total tablets
		var totalTablets = Math.floor((totalGrams * 1000) / tabletWeightMg); // Convert grams to mg and calculate tablets

		if (totalGrams > 0) {
			// Calculate price per tablet
			//var pricePerTablet = (unitPriceCents / totalTablets) / 100; // Convert price from cents to currency
			var pricePerTablet = ((unitPriceCents / totalGrams) / 100) * 1000; // Price per kg in dollars
			console.log('pricePerTablet', pricePerTablet);
			// Format as money using dynamic currency
			var formattedPrice = pricePerTablet.toLocaleString('nl-NL', {
				style: 'currency',
				currency: currencyType,
				currencyDisplay: 'symbol', // Ensures symbol (€, $, etc.) is used
				minimumFractionDigits: 3,
				maximumFractionDigits: 3
			});

			console.log($('.main-product-page-tablet').find('.price-per-gram').children().text(formattedPrice), formattedPrice, 'formattedPrice');

			$('#pricePerGram').text(formattedPrice);
		} else {
			// $('.main-product-page-powder').find('.price-per-gram').children().text('N/A');
		}
	}

	// Function to update values and recalculate price per gram
	function updateVariantPricing(variantData) {
		setTimeout(function () {
			var unitPriceCents = variantData.price; // should be 3299 
			var totalGrams = $('.main-product-page-powder').find('.total-grams').data('grams'); // should be 1000
			var currencyType = $('.main-product-page-powder').find('.currency-type').data('currency');
			console.log('Unit Price (cents):', unitPriceCents);
			console.log('Total Grams:', totalGrams);
			console.log('Currency Type:', currencyType);
			calculatePricePerGramvariant(unitPriceCents, totalGrams, currencyType);
		}, 1000);
	}

	function updateVariantPricingtablet(variantData) {
		setTimeout(function () {
			var unitPriceCents = variantData.price; // should be 3299 
			var totalGrams = $('.main-product-page-tablet').find('.total-grams').data('grams'); // should be 1000
			var currencyType = $('.main-product-page-tablet').find('.currency-type').data('currency');
			console.log('Unit Price (cents):', unitPriceCents);
			console.log('Total Grams:', totalGrams);
			console.log('Currency Type:', currencyType);
			calculatePricePerGramtabletvariant(unitPriceCents, totalGrams, currencyType);
		}, 1000);
	}

    const updatePreorderStatus = (variantId) => {
      const preorderStatusElements = document.querySelectorAll('.custom-uspstatus');
      preorderStatusElements.forEach((element) => {
        const isCurrentVariant = element.dataset.variantId == variantId;
        element.style.display = isCurrentVariant ? 'block' : 'none'; // Show only for the current variant
      });
    };

    

	// Handle variant selection
	$('input.product-custom-variable').change(function () {
		console.log($(this).data('variantid'));
		// Fetch the variant data from the embedded JSON in the script tag
		var variantDataJSON = $('script.variantproduct-json-radio[type="application/json"]').html();
		console.log('variantDataJSON', variantDataJSON);
		// Check if JSON is retrieved correctly
		if (!variantDataJSON) {
			console.error('No JSON data found in the script tag.');
			return;
		}
		var productData;
		try {
			productData = JSON.parse(variantDataJSON);
			console.log('Parsed Product Data:', productData); // Log the entire productData
		} catch (e) {
			console.error('Failed to parse JSON on initial load:', e);
			return;
		}
		console.log('productData', productData, Array.isArray(productData));
		// Access variants
		if (Array.isArray(productData)) {
			var defaultSelectedVariantid = $('input.product-custom-variable:checked').data('variantid');
			console.log('Selected Variant ID:', defaultSelectedVariantid);
			var defaultVariant = productData.find(variant => variant.id === defaultSelectedVariantid);
			console.log('defaultVariant', defaultVariant, defaultVariant.id);
			if (defaultVariant) {
				updateVariantPricing(defaultVariant);
				updateVariantPricingtablet(defaultVariant);
                updatePreorderStatus(defaultVariant.id);
			} else {
				console.error('Default variant not found for ID:', defaultSelectedVariantid);
			}
		} else {
			console.error('Product data is not an array:', productData);
		}
	});
});